export { SimpleIcon, type SimpleIconProps } from "./SimpleIcon";
